
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["lo-price-icon__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53.9 53.9"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"27","cy":"27","r":"27"}}),_c('path',{staticClass:"st1",attrs:{"fill":"#fff","d":"M36.7 33.6H20.9c-.4 0-.8-.3-1-.6l-6.8-16.1H9.9c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h3.9c.4 0 .8.3 1 .6l1.5 3.5h25.4c.4 0 .7.1.8.5.2.3.2.6.1 1L37.7 33c-.2.4-.5.6-1 .6zm-15.1-2.2h14.5l4-10.5H17.2l4.4 10.5zM23 42.8c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7 3.7 1.7 3.7 3.7c-.1 2.1-1.7 3.7-3.7 3.7zm0-5.2c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5zM34.2 42.8c-2 0-3.7-1.7-3.7-3.7s1.7-3.7 3.7-3.7 3.7 1.7 3.7 3.7c0 2.1-1.7 3.7-3.7 3.7zm0-5.2c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5c.1-.8-.6-1.5-1.5-1.5z"}})])
          )
        }
      }
    